import { ref, watch } from 'vue';

const STORAGE_KEY = 'app.sidebarCollapsed';

function readInitial(): boolean {
  if (typeof localStorage === 'undefined') return false;
  return localStorage.getItem(STORAGE_KEY) === '1';
}

const collapsed = ref<boolean>(readInitial());

watch(collapsed, (val) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, val ? '1' : '0');
  }
});

export function useSidebar() {
  return {
    collapsed,
    toggle() {
      collapsed.value = !collapsed.value;
    },
  };
}
